export enum ProductType {
  SUNGLASSES = 'SUNGLASSES',
  FRAMES = 'FRAMES',
  CONTACT_LENS = 'CONTACT_LENS',
}
